<template>
  <div class="FinancesInvoicesCompanySpecialisationsTable">
    <b-table :fields="fields" :items="items">
      <template #cell(specialisation_id)="{ item, index }">
        <b-form-select
          v-model="item.specialisation_id"
          @change="dataTouched(index, 'cost')"
          :options="getSpecialisations"
          value-field="id"
          text-field="type_display_name"
        />
      </template>
      <template #cell(hours)="{ item, index }">
        <b-form-input
          type="number"
          step="0.01"
          no-wheel
          v-model="item.hours"
          @input="dataTouched(index, 'hours')"
        />
      </template>
      <template #cell(cost)="{ item, index }">
        <b-form-input
          type="number"
          no-wheel
          v-model="item.cost"
          @input="dataTouched(index, 'cost')"
        />
      </template>
      <template #cell(actions)="data" v-if="items.length > 1">
       <b-button variant="danger" size="sm" @click.prevent="removeItem(data)">
         <font-awesome-icon icon="trash" />
       </b-button>
      </template>
    </b-table>
    <b-button @click.prevent="addItem" variant="info">
      Add item
    </b-button>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'

const defaultItem = {
  'specialisation_id': null,
  'hours': null,
  'cost': null
}

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fields: [
        { key: 'specialisation_id', label: 'Specialisation', class: 'item-type-column' },
        { key: 'hours', label: 'Hours', class: 'hours-column' },
        { key: 'cost', label: 'Cost', class: 'cost-column' },
        { key: 'actions', label: '', class: 'actions-column' }
      ],
      items: []
    }
  },
  computed: {
    ...mapGetters({
      getSpecialisations: 'finances/getSpecialisations'
    })
  },
  mounted () {
    this.fetchSpecialisations()
      .then(() => {
        this.setInitialParams()
      })
  },
  watch: {
    'value': {
      deep: true,
      handler () {
        this.setInitialParams()
      }
    }
  },
  methods: {
    setInitialParams () {
      this.items = this.value || [cloneDeep(defaultItem)]
      this.triggerInputEmit()
    },
    async fetchSpecialisations () {
      return this.$api.finances.getInvoiceProjectSpecialisations()
    },
    addItem () {
      this.items.push(cloneDeep(defaultItem))
      this.triggerInputEmit()
    },
    removeItem (data) {
      const removedIndex = data.index
      this.items = this.items.filter((item, index) => index !== removedIndex)
      this.triggerInputEmit()
      this.$emit('dataRemoved', { removedIndex })
    },
    triggerInputEmit () {
      this.$emit('input', this.items)
    },
    dataTouched (index, attrName) {
      this.$emit('dataTouched', { index, attrName })
    }
  }
}
</script>

<style lang="scss">
  .FinancesInvoicesCompanySpecialisationsTable{
    margin-bottom: 1rem;
    .item-type-column{
      min-width: 200px;
    }
    .hours-column,
    .cost-column {
      min-width: 110px;
    }
    .actions-column {
      min-width: 40px;
    }
    .comment-column {
      width: 100%;
    }
  }
</style>
